var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React from "react";
import BrowserImage from "../assets/images/libs/core/browsers.png";
import NewVersion from "../assets/images/libs/core/newversion.png";
import { Div } from "../components/core/03-base/Div";
import { ModalNotification } from "../components/core/09-views/03-modals/Notification";
import { ThemePalette } from "../theme/_Types";
import * as I18n from "./translations/I18n";
export var ModalGenericWarning = function (props) { return (React.createElement(ModalNotification, { id: props.id, onCloseModal: props.onClose, message: props.message },
    React.createElement(React.Fragment, null,
        React.createElement(Div, null,
            React.createElement("img", { src: BrowserImage, alt: "IE xD!", style: {
                    maxWidth: "75px",
                    alignSelf: "center",
                    margin: "0 auto",
                    display: "block",
                    transform: "translateX(15px)",
                } })),
        React.createElement("div", { className: "scl-b-h5 scl-b-h" }, I18n.getText("mary.utils.verifycontext.browser-support", "Browser support")),
        React.createElement("br", null),
        React.createElement("p", null, props.message)))); };
export var ModalNewVersionAvailable = function (props) { return (React.createElement(ModalNotification, { id: props.id, title: I18n.getText("mary.utils.verifycontext.newversion-title", "Notification"), onCloseModal: props.onClose, message: props.message, theme: {
        palette: ThemePalette.BRAND_ACCENT,
    } },
    React.createElement(React.Fragment, null,
        React.createElement(Div, null,
            React.createElement("img", { src: NewVersion, alt: "New App. Version", style: {
                    maxWidth: "150px",
                    alignSelf: "center",
                    margin: "0 auto",
                    display: "block",
                    transform: "translateX(15px)",
                } })),
        React.createElement("div", { className: "scl-b-h5 scl-b-h" }, I18n.getText("mary.utils.verifycontext.newversion-description", "New version available!")),
        React.createElement("br", null),
        React.createElement("p", null, props.message)))); };
var checkBrowsers = function (handleBrowserNotification) {
    var _a;
    var isIe = false || !!document.documentMode;
    if (isIe) {
        handleBrowserNotification((_a = I18n.getText("mary.utils.verifycontext.browsersupport-description", "We don't actively support this browser, because of security and UI/UX reasons. \n \n\n            Please use one of the more modern browers like Chrome, Edge, Firefox or Safari.")) !== null && _a !== void 0 ? _a : "");
    }
};
var semverGreaterThan = function (versionA, versionB) {
    var versionsA = versionA.split(/\./g);
    var versionsB = versionB.split(/\./g);
    while (versionsA.length || versionsB.length) {
        var a = Number(versionsA.shift());
        var b = Number(versionsB.shift());
        // eslint-disable-next-line no-continue
        if (a === b) {
            continue;
        }
        // eslint-disable-next-line no-restricted-globals
        return a > b || isNaN(b);
    }
    return false;
};
var checkAppVersion = function (handleBrowserNotification) {
    var _a;
    var isIe = false || !!document.documentMode;
    if (!isIe) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        fetch("".concat((_a = process.env.PUBLIC_URL) !== null && _a !== void 0 ? _a : "", "/meta.json?").concat(new Date().getTime()), { cache: "no-cache" })
            .then(function (response) { return response.json(); })
            .then(function (meta) {
            var _a, _b, _c;
            var latestVersion = meta.version;
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            var packageJson = require("../../package.json");
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            var shouldForceRefresh = semverGreaterThan(latestVersion, packageJson.version);
            if (shouldForceRefresh) {
                var notificationMessage = (_b = I18n.getText("mary.utils.verifycontext.newversionavailable-message", "There is a new version ({{version}}) of the {{app-name}} application. You should refresh to get the latest features and/or bugfixes.", { "version": latestVersion, "app-name": (_a = process.env.REACT_APP_TITLE) !== null && _a !== void 0 ? _a : "Application" })) !== null && _b !== void 0 ? _b : "";
                console.log(notificationMessage);
                handleBrowserNotification(notificationMessage);
            }
            else {
                console.log(I18n.getText("mary.utils.verifycontext.version-message", "{{app-name}} by Claude is running the latest version: v{{version}}", { "version": latestVersion, "app-name": (_c = process.env.REACT_APP_TITLE) !== null && _c !== void 0 ? _c : "Application" }));
            }
        });
    }
};
/**
 * VerifyContext implements Claude's root component.
 */
var VerifyContext = /** @class */ (function (_super) {
    __extends(VerifyContext, _super);
    function VerifyContext(props) {
        return _super.call(this, props) || this;
    }
    VerifyContext.prototype.componentDidMount = function () {
        checkBrowsers(this.props.handleBrowserNotification);
        checkAppVersion(this.props.handleNewAppVersion);
    };
    VerifyContext.prototype.render = function () {
        return this.props.children;
    };
    return VerifyContext;
}(React.Component));
export { VerifyContext };
export var testUtil = {
    checkBrowsers: checkBrowsers,
    genericWarningModal: ModalGenericWarning,
    newVersionAvailableModal: ModalNewVersionAvailable,
    semverGreaterThan: semverGreaterThan,
    checkAppVersion: checkAppVersion,
};
